import { render, staticRenderFns } from "./CampaignsCreate.vue?vue&type=template&id=45c5a366&"
import script from "./CampaignsCreate.vue?vue&type=script&lang=js&"
export * from "./CampaignsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports